module.exports = __webpack_public_path__ + "static/img/25.7ae1e9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/25.jpg
// module id = Sjw7
// module chunks = 0